import api from 'Application/api/api';

const respondForNewProject = (signal, values) =>
	api.put('/inquiries/respond-new-project', values, {
		signal,
	});

export default respondForNewProject;
